import { useState, useEffect, useMemo, useRef } from "react";
import { useLayoutEffect } from "@tkww/orion-web-lib-react";
import { getProxy } from "../getProxy.js";
export const useZendeskWidget = () => {
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const proxyRef = useRef();
  useLayoutEffect(() => {
    proxyRef.current = getProxy();
    setIsLoading(proxyRef.current.isLoading);
  }, []);
  useEffect(() => {
    const onOpen = () => {
      setIsOpen(true);
    };
    const onClose = () => {
      setIsOpen(false);
    };
    const onUnreadMessages = evt => {
      setUnreadMessages(evt.detail.count);
    };
    const onLoadingStateChange = evt => {
      setIsLoading(evt.detail.isLoading);
    };
    const proxy = proxyRef.current;
    proxy.addEventListener('loadingStateChange', onLoadingStateChange);
    proxy.addEventListener('open', onOpen);
    proxy.addEventListener('close', onClose);
    proxy.addEventListener('unreadMessages', onUnreadMessages);
    return () => {
      proxy.removeEventListener('loadingStateChange', onLoadingStateChange);
      proxy.removeEventListener('open', onOpen);
      proxy.removeEventListener('close', onClose);
      proxy.removeEventListener('unreadMessages', onUnreadMessages);
    };
  }, []);
  const actions = useMemo(() => ({
    setZIndex: value => {
      proxyRef.current.zIndex = value;
    },
    setLocale(value) {
      proxyRef.current.locale = value;
    },
    open: () => {
      var _proxyRef$current;
      (_proxyRef$current = proxyRef.current) === null || _proxyRef$current === void 0 || _proxyRef$current.open();
    },
    close: () => {
      var _proxyRef$current2;
      (_proxyRef$current2 = proxyRef.current) === null || _proxyRef$current2 === void 0 || _proxyRef$current2.close();
    }
  }), []);
  const data = useMemo(() => ({
    isLoading,
    isOpen,
    unreadMessages
  }), [isLoading, isOpen, unreadMessages]);
  return [data, actions];
};